import React from "react";
import "./SettlementStatus.css";
import { PiClockBold } from "react-icons/pi";
import { BsCheckCircle, BsDot } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { SettlementReqStatus } from "../../Helpers/Enums/ApplicationStatus";


export enum SettlementModule {
  SettlementDetails = 3,
}

const SettlementStatus = ({
  statusId,
  SettlementNameModule,
  rejectReasons = "",
}) => {
  switch (SettlementNameModule) {
    case SettlementModule.SettlementDetails:
      switch (statusId) {
        case SettlementReqStatus.Settlement_Approval_Pending:
        case SettlementReqStatus.Settlement_Approved:
          return (
            <div className="reg-status-container reg-status-container-pending">
              <div className="d-flex justify-content-center align-items-center">
                <PiClockBold className="reg-status-icon reg-status-icon-pending mx-2" />
                <span className="reg-status-text reg-status-text-pending">
                  The status of your application is under approval. We will
                  notify you as soon as it gets approved.
                </span>
              </div>
            </div>
          );
        case SettlementReqStatus.Settlement_Approved:
          return (
            <div className="reg-status-container reg-status-container-approved">
              <div className="d-flex justify-content-center align-items-center">
                <BsCheckCircle className="reg-status-icon reg-status-icon-approved mx-2" />
                <span className="reg-status-text reg-status-text-approved">
                  Verification Completed Successfully.
                </span>
              </div>
            </div>
          );
        case SettlementReqStatus.Settlement_Rejected:
          return (
            <div className="reg-status-container reg-status-container-rejected">
              <div className="d-flex justify-content-center align-items-center">
                <AiOutlineCloseCircle className="reg-status-icon reg-status-icon-rejected mx-2" />
                <span className="reg-status-text reg-status-text-rejected">
                  Unfortunately, your application has been rejected, due to the
                  following reasons:
                </span>
              </div>
              <span className="reg-status-text reg-status-text-rejected">
                <ul>
                  {/* {rejectReasons?.map((rr) => {
                    return ( */}
                      <li>
                        <BsDot className="rejected-bullet" />
                        {rejectReasons}
                      </li>
                {/* //     );
                //   })} */}
                </ul>
              </span>
            </div>
          );
        default:
          return null;
      }
    default:
      return null;
  }
};

export default SettlementStatus;
